import styled from '@emotion/styled';
import { COLOR, FONT_SIZE, FONT_WEIGHT } from '@ordermentum/ui-constants';

export const FieldErrorContainer = styled('div')`
  position: relative;
  height: 0;
`;

export const FieldErrorWrapper = styled('div')`
  position: absolute;
  padding: 0.75rem;
  background-color: ${COLOR.WHITE};
  border-radius: 1px;
  border: 1px solid ${COLOR.RED};
  top: 0.7rem;
  color: ${COLOR.RED};
  font-size: ${FONT_SIZE.SM};
  font-weight: ${FONT_WEIGHT.MEDIUM};
  z-index: 2;

  &:before {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 11px solid transparent;
    border-bottom: 10px solid ${COLOR.RED};
    left: 5%;
    top: -21px;
  }

  &:after {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-bottom: 10px solid ${COLOR.WHITE};
    left: calc(5% - 0px);
    top: -19px;
  }
`;
